// @flow
// cooldown - When the operator just ended a call
export const AVAILABLE = 'Available';
export const AWAY = 'Away';
export const DND = 'DND';
export const BUSY = 'Busy';
export const TALKING = 'Talking';
export const OFFLINE = 'Offline';
export const COOLDOWN = 'Cooldown';

const PRESENCES = {
    [AVAILABLE]: {
        color: '#bdcc41',
        label: 'Available',
    },
    [AWAY]: {
        color: '#1381b2',
        label: 'Away',
    },
    [DND]: {
        color: '#e5393e',
        label: 'DND',
    },
    [BUSY]: {
        color: '#f9af48',
        label: 'Busy',
    },
    [TALKING]: {
        color: '#aa88db',
        label: 'Talking',
    },
    [OFFLINE]: {
        color: '#adb0b8',
        label: 'Offline',
    },
    [COOLDOWN]: {
        color: '#65cee2',
        label: 'Cooldown',
    },
};

export const mapPresenceToStatus = (presence) => {
    if (!presence) return OFFLINE;

    const { basic, note, activities } = presence;

    return Object.keys(PRESENCES).find((key) => PRESENCES[key].basic === basic
        && ((PRESENCES[key].activity && activities.includes(PRESENCES[key].activity))
            || (PRESENCES[key].note && note.includes(PRESENCES[key].note))))
        || OFFLINE;
};

export default PRESENCES;
